// Simple PDP countdown timer
function initPdpCountdowns() {
  const timers = document.querySelectorAll('.js-pdp-countdown');
  if (!timers.length) return;

  timers.forEach(timer => {
    const endStr = timer.getAttribute('data-countdown-end');
    if (!endStr) return;

    const endTime = new Date(endStr).getTime();
    if (isNaN(endTime)) return;

    const hoursEl = timer.querySelector('[data-unit="hours"]');
    const minutesEl = timer.querySelector('[data-unit="minutes"]');
    const secondsEl = timer.querySelector('[data-unit="seconds"]');

    if (!hoursEl || !minutesEl || !secondsEl) return;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function update() {
      const now = Date.now();
      let diff = Math.max(0, endTime - now);

      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);

      // Stop when it hits zero
      if (diff <= 0) {
        clearInterval(interval);
      }
    }

    update();
    const interval = setInterval(update, 1000);
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initPdpCountdowns);

// If your theme uses smooth transitions / AJAX navigation,
// re-init when new sections are loaded:
document.addEventListener('shopify:section:load', initPdpCountdowns);
